import { Component, OnInit, AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
  Output,
  EventEmitter } from '@angular/core';
import { AuthenticationService } from "../services/authentication.service";
import Swal from 'sweetalert2'
import { StripeToken, StripeSource } from "stripe-angular";
import { NgForm } from "@angular/forms";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  @Output() updateTrackMenu = new EventEmitter();
  @ViewChild("cardInfo") cardInfo: ElementRef;
  existingCards: any = [];
  card: any;
  public form: FormGroup;
  public invalidError:any;
  cardHandler = this.onChange.bind(this);
  error: string;
  promocode: string = "";
  defaultCard: string;
  showSpinner: Boolean = true;
  enablePromo: Boolean = false;
  isCouponValid: Boolean = false;
  copuonAppliedMsg: string = "";
  discount: any = 0;
  coupon: string = "";
  couponApplied: Boolean = false;
  public cards = [];
  public cardId:any;
  amount: any = 0;
  loadingMsg: string = "Loading ...";
  public user:any;
  public plan:any;
  public criteria:any;
  public applyCouponId:any;
  spinnerType = SPINNER.circle;
  constructor(public fb: FormBuilder, public router: Router,private ngxService: NgxUiLoaderService, public authenticationService: AuthenticationService) { }
  ngOnInit(): void {
    this.cardList()
    this.criteria = JSON.parse(localStorage.getItem('criteria'));
    this.plan = JSON.parse(localStorage.getItem('plan'));
    console.log(this.criteria, 'this.plan')
    this.user = this.authenticationService.currentUserValue;
    this.form = this.fb.group({
      couponId: [null, []],
    }); 
  }
  cardReady = false;
  ngAfterViewInit() {
    this.card = elements.create("card");
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener("change", this.cardHandler);
  }
  onStripeInvalid( error:Error ){
    console.log('Validation Error', error)
  }
 
  setStripeToken( token:StripeToken ){
    console.log('Stripe token', token)
  }
 
  setStripeSource( source:StripeSource ){
    console.log('Stripe source', source)
  }
 
  onStripeError( error:Error ){
    console.error('Stripe error', error)
  }
  ngOnDestroy() {
    this.card.removeEventListener("change", this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    // this.cd.detectChanges();
  }

  applyCoupon(coupon) {
    this.applyCouponId = coupon.couponId;
    this.ngxService.start();
    this.authenticationService.coupon({ couponId: this.applyCouponId, amount: this.criteria.amount}).subscribe(
      data => {
        this.couponApplied = true;
        Swal.fire(
          "",
          "Coupon is applied successfully",
          "success"
        )
        this.ngxService.stop();
      },
      error => {
        Swal.fire(
          "error",
          error.error.message
        )
        console.log(error, 'testing')
        this.ngxService.stop();
      }
    );
  }
 
  addCard(token) { 
    this.authenticationService.addCard({ stripeToken: token }).subscribe(
      data => {
        this.cardList() 
        Swal.fire(
          "",
          "Card is added successfully",
          "success"
        )
        this.ngxService.stop();
      },
      error => {
        this.ngxService.stop();
        Swal.fire(
          "Error",
          error.error.message,
          "error"
        )
      }
    );
  }
  async onSubmit(form: NgForm) {
    this.ngxService.start();
    const { token, error } = await stripe.createToken(this.card);
    if (error) {
      Swal.fire(
        "Oops...",
        error.message,
        "error"
      );
      this.ngxService.stop();
    } else {
      if(token.id){
        this.addCard(token.id);
      } 
     
      // this.requestPayment(token.id)
    }
  }
  removeCard(cardId) {
    this.ngxService.start();
    this.authenticationService.removeCard({ cardId: cardId }).subscribe(
      data => {
        this.ngxService.stop();
        this.copuonAppliedMsg = "Card is removed successfully";
        this.cardList()
        Swal.fire(
          "",
           this.copuonAppliedMsg,
          "success"
        )
      },
      error => {
        this.ngxService.stop();
        Swal.fire(
          "Error",
          error.error.message,
          "error"
         
        )
      }
    );
  }
  cardList(){
    this.authenticationService.cardList().subscribe(
      data => {
        this.cards = data['data'].cards
        if(this.cards && this.cards.length > 0){
          this.cardId = this.cards[0].id
          this.defaultCard = '';
        } else {
          this.cardId = ''
        }
      },
      error => {
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }
 
  validateSub(){
    this.authenticationService.validateSubscription(this.criteria).subscribe(
      data => {
        console.log(data, 'validate')
      },
      error => {
        console.log(error)
        Swal.fire(
          "Error",
          error.error.message,
          "error"
         
        );
      }
    );
 
  }
  
  requestPayment(source) {
    
    if(!source || source == undefined){
      Swal.fire(
        "Error",
        "Please add your card to continue payment.",
        "error"
      )
      return
    } 
    this.criteria = JSON.parse(localStorage.getItem('criteria'));
    this.ngxService.start();
    console.log(this.criteria.refrenceId)
    this.authenticationService.requestPayment({
      refrenceId: this.criteria.refrenceId,
      isRecurring:"false",
      // isCouponApplied: this.couponApplied,
      // couponId:this.applyCouponId,
      // amount: this.criteria.amount,
      stripeToken: source
    }).subscribe(
      data => {
        // this.loadExistingCards();
        this.ngxService.stop();
        // this.validateSub()
        Swal.fire(
          "Thanks you",
          "Thank you for the recent payment you have made for us.",
          "success"
         
        );
        this.router.navigate(['/payment-sucess']);
      },
      error => {
        console.log(error)
        this.ngxService.stop();
        Swal.fire(
          "Error",
          error.error.message,
          "error"
         
        );
      }
    );
  }
  useDefault(cardId) {
    this.requestPayment(cardId)
  }
  redirect(){
    this.router.navigate(['/dashboard']);
  }
}
